'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    OpenApiViewerController.$inject = ['$stateParams'];
    angular.module('app.api').component('openApiViewer', {
        require: { app: "^app" },
        template: '<div style="padding: 2em 2em;" translate-namespace="api"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><ol class="breadcrumb pull-left"><li ng-repeat="breadcrumb in $ctrl.app.breadcrumbs"><a href="{{breadcrumb.url}}">{{breadcrumb.label}}</a></li><li><a ui-sref="api" translate>.Api</a></li><li translate>{{$ctrl.title}}</li></ol><div class="pull-right"><login-widget></login-widget></div></div></div><div class="row"><div class="col-lg-12"><div swagger-ui url="$ctrl.jsonPath" api-explorer="false" validator-url="false" parser="json"></div></div></div></div>',
        controller: OpenApiViewerController,
        controllerAs: '$ctrl'
    });

    function OpenApiViewerController($stateParams) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {
            $ctrl.title = $stateParams.title;
            $ctrl.jsonPath = $ctrl.app.uri + $stateParams.jsonPath;
        };
    }
})();